document.addEventListener('DOMContentLoaded', () => {

  let images = [...document.getElementsByClassName('Tabs__picture')];
  let contents = [...document.getElementsByClassName('Tabs__content')];
  let buttons = [...document.getElementsByClassName('Tabs__button')];
  let buttonLinks = [...document.getElementsByClassName('button-link')];
  
  images[0].classList.add('Tabs__picture--active');
  contents[0].classList.add('Tabs__content--active');
  buttons[0].classList.remove('button-base-secondary');

  buttonLinks.forEach((link, index) => {
    let slug = slugify(link.innerHTML);
    let location = window.location.search.replace('?','');

    if(location == slug){
      buttons.forEach(buttonActive => {
        buttonActive.classList.add('button-base-secondary');
      });
      buttons[index].classList.remove('button-base-secondary');

      contents[0].classList.remove('Tabs__content--active');
      contents[index].classList.add('Tabs__content--active');

      images[0].classList.remove('Tabs__picture--active');
      images[index].classList.add('Tabs__picture--active');
    }
  })

  buttons.forEach((button,index) => {
    button.addEventListener('click', () => {
      buttons.forEach(buttonActive => {
        buttonActive.classList.add('button-base-secondary');
      });
      button.classList.remove('button-base-secondary');

      contents.forEach(content => {
        content.classList.remove('Tabs__content--active');
      });
      contents[index].classList.add('Tabs__content--active');

      images.forEach(image => {
        image.classList.remove('Tabs__picture--active');
      });
      images[index].classList.add('Tabs__picture--active');
    });
  });
});

function slugify(str)
{
    str = str.replace(/^\s+|\s+$/g, '');

    // Make the string lowercase
    str = str.toLowerCase();

    // Remove accents, swap ñ for n, etc
    var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
    var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    // Remove invalid chars
    str = str.replace(/[^a-z0-9 -]/g, '') 
    // Collapse whitespace and replace by -
    .replace(/\s+/g, '-') 
    // Collapse dashes
    .replace(/-+/g, '-'); 

    return str;
}
